export default __webpack_public_path__ + "static/media/basic-pin-small-6.542950ea.png";